define('modules/base/views/base.search.reset.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'text!modules/base/templates/base.search.reset.template.html',
    'modules/base/views/base.view'
], function(
    Prospector,
    $,_,Backbone,
    Marionette,
    Template,
    BaseView
){
    var BaseSearchResetView = BaseView.extend({
        template: _.template(Template),
        className: 'searchReset',
        events:{
            'click .reset_icon' : 'resetSearch'
        },
        resetSearch:function() {
            this.$('.searchBar').val("");
            this.resetShow();
        },
        resetShow: function() {
            if(this.$('.searchBar').val() != undefined && this.$('.searchBar').val().length > 0){
                this.$('.reset_icon').show();
            } else {
                this.$('.reset_icon').hide();
            }
        },
        onRender:function() {
            this.$('.reset_icon').hide();
            this.$('.searchBar').on('keyup', $.proxy(this.resetShow, this));
        }
    });
    return BaseSearchResetView;
});
